// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsLink__root--1rORf","inlined":"DetailsLink__inlined--1oJK9 DetailsLink__root--1rORf","edit":"DetailsLink__edit--WLj-- DetailsLink__root--1rORf"};